<template>
    <div>
        <el-upload
            class="upload-video"
            drag
            action="/wapi/base/upload"
            :file-list="fileList"
            accept='video/*'
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple>
            <img src="../assets/images/video_upload_icon.png" />
            <div class="el-upload__text">
                <p class="bigger">点击上传视频文件</p>
                <p class="detail">支持格式：.MP4 .FLV</p>
            </div>
        </el-upload>
         <el-dialog title="视频预览" :visible.sync="videoVisible">
            <video controls loop style="width: 100%; height: 100%" :src="videoUrl"  v-if="videoUrl && videoVisible" autoplay></video>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'upload-video',
    props: {
        videoList: {
            type: Array,
            default: () => []
        },
        limit: {
            type: Number,
            default: 3
        }
    },
    data () {
        return {
            videoVisible: false,
            videoUrl: ''
        }
    },
    computed: {
        fileList(){
            return this.videoList.map(item => {
                return {
                    url: item,
                    name: item.split('/').pop()
                }
            })  
        }
    },
    watch: {
        videoList(newVal, oldVal) {
            this.$emit('change', newVal)
        }
    },
    methods: {
        handleBeforeUpload(file) {
            if (this.videoList.length >= this.limit) {
                this.$message.error('最多上传 ' + this.limit +'张视频');
                return false
            }
            const isLtM = file.size / 1024 / 1024 < 25;
            if (!isLtM) {
                this.$message.error('上传视频大小不能超过 25MB!');
                return false
            }
            return true
        },
        handleSuccess (file) {
            this.videoList.push(file.data)
        },
        handleRemove(file) {
            this.videoList.splice(this.videoList.indexOf(file.url), 1)
        },
        handlePreview(file) {
            this.videoVisible = true;
            this.videoUrl = file.url
        },
    }
}
</script>


// WEBPACK FOOTER //
// VideoUpload.vue?13b44c46